import { Component } from '@angular/core';

@Component({
  selector: 'app-sblock-consultancies',
  templateUrl: './consultancies.component.html',
  styleUrls: ['./consultancies.component.scss'],
})
export class SblockConsultanciesComponent {
  showTitles = true;
  title = 'Asesorías y acompañamiento';
  subtitle = 'Sesiones personalizadas con nuestros profesionales especializados.';
  titlesColor = '#2B3892';
  secondaryColor = '#555555';
  linkColor = '#2B3892';
  buttonText = 'Ver todas las asesorías';

  consultancyList = [
    {
      id: 1,
      heroImageSmall: 'https://picsum.photos/seed/consult-orientacion/400/300',
      title: 'Orientación vocacional',
      price: '40 €',
      priceGlobal: '45 USD',
    },
    {
      id: 2,
      heroImageSmall: 'https://picsum.photos/seed/consult-familiar/400/300',
      title: 'Acompañamiento familiar',
      price: '35 €',
      priceGlobal: '',
    },
    {
      id: 3,
      heroImageSmall: 'https://picsum.photos/seed/consult-espiritual/400/300',
      title: 'Dirección espiritual',
      price: '',
      priceGlobal: '30 USD',
    },
  ];

  btn1Active = true;
  btn1Es = 'Reservar una sesión';
  btn1Link = '#';
  btn1Align = 'center';

  btn2Active = true;
  btn2Es = 'Contactar';
  btn2Link = '#';
}
